import { withLayout } from 'pages/GuestLayout';

import ForgotPasswordPage from './ForgotPasswordPage';

export default withLayout('Forgot Password', ForgotPasswordPage);
